function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from 'react';
import PropTypes from 'prop-types';
import times from 'lodash/times';
import ButtonBase from '@material-ui/core/ButtonBase';
import componentPropType from '@signal/prop-types/component';
import renderIf from '@signal/utils/renderIf';
import { ActiveDot, InactiveDot, Wrapper } from './styles';
var USE_STATE_FOR_ACTIVE_STEP = -1;
export var DotStepper = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(DotStepper, _React$PureComponent);

  var _super = _createSuper(DotStepper);

  function DotStepper(props) {
    var _this;

    _classCallCheck(this, DotStepper);

    for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this, props].concat(rest));

    _defineProperty(_assertThisInitialized(_this), "handleStepChange", function (stepIndex) {
      return function () {
        var _this$props = _this.props,
            activeStep = _this$props.activeStep,
            onStepChange = _this$props.onStepChange;
        onStepChange(stepIndex);

        if (activeStep === USE_STATE_FOR_ACTIVE_STEP) {
          _this.setState({
            activeStep: stepIndex
          });
        }
      };
    });

    _this.state = {
      activeStep: props.startStep
    };
    return _this;
  }

  _createClass(DotStepper, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          ActiveDotComponent = _this$props2.ActiveDotComponent,
          InactiveDotComponent = _this$props2.InactiveDotComponent,
          activeStep = _this$props2.activeStep,
          stepCount = _this$props2.stepCount,
          onStepChange = _this$props2.onStepChange,
          rest = _objectWithoutProperties(_this$props2, ["ActiveDotComponent", "InactiveDotComponent", "activeStep", "stepCount", "onStepChange"]);

      var activeStepUse = activeStep === USE_STATE_FOR_ACTIVE_STEP ? this.state.activeStep : activeStep;
      return /*#__PURE__*/React.createElement(Wrapper, rest, times(stepCount).map(function (stepIndex) {
        return /*#__PURE__*/React.createElement(ButtonBase, {
          focusRipple: true,
          key: "button_".concat(stepIndex),
          onClick: _this2.handleStepChange(stepIndex),
          TouchRippleProps: {
            style: {
              borderRadius: '50%'
            }
          }
        }, renderIf(activeStepUse === stepIndex, function () {
          return /*#__PURE__*/React.createElement(ActiveDotComponent, null);
        }, function () {
          return /*#__PURE__*/React.createElement(InactiveDotComponent, null);
        }));
      }));
    }
  }]);

  return DotStepper;
}(React.PureComponent);

_defineProperty(DotStepper, "propTypes", {
  ActiveDotComponent: componentPropType,
  InactiveDotComponent: componentPropType,
  activeStep: PropTypes.number,
  startStep: PropTypes.number.isRequired,
  stepCount: PropTypes.number.isRequired,
  onStepChange: PropTypes.func.isRequired
});

_defineProperty(DotStepper, "defaultProps", {
  ActiveDotComponent: ActiveDot,
  InactiveDotComponent: InactiveDot,
  activeStep: USE_STATE_FOR_ACTIVE_STEP
});

export default DotStepper;